import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import Sidebar from '../common/sidebar';
import Topbar from '../common/topbar';

export function Layout({ children }) {
  return (
    <Box>
      <Flex>
        <Sidebar />
        <Box w="100%">
          <Topbar />
          <Box
            className="blockBg"
            px={{ base: '0', md: '7' }}
            py={5}
            minH="container.md"
            rounded="10"
            mr={{ base: '0', md: '8' }}
            mb="10"
            boxShadow="7"
          >
            {children}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

export const noop = 'value';
